import Vue from 'vue'
import  _ from 'lodash'

function createFormItem(formItemType, payload, next, parent) {
    const nextFunc = (current, acients) => {
        const formData = acients.reduce((acc, item) => {
            acc[item.payload.field] = item.payload.value;
            return acc;
        }, {});

        let nextItem = next(current, acients, formData);
        if (nextItem) {
            nextItem.parent = current;
        }
        return nextItem;
    };

    return {
        type: formItemType,
        payload: Vue.observable(payload),
        next: nextFunc,
        parent: parent || null
    };
} ;

export function createFormItemFactory({
    displayType,appList, vm, ideaList
}) {
    const appListFormItem = createFormItem('WkListCheck', {
        value: _.head(appList).value,
        field: 'app_id',
        label: '产品',
        props: {
            list: appList,
            label: '创意组'
        }
    }, (formState)=> {
        return displayTypeFormItem(displayType)

    });
    const displayTypeFormItem =(list)=> {
        return  createFormItem('WkListCheck', {
                value: _.head(list).value,
                field: 'display_type',
                label: '版位',
                props: {
                    list: displayType,
                    label: '创意组'
                }
            }, (formState, acients, formData)=> {
                const value = formState.payload.value;
                const data = ideaList.find(item => item.ad_placement_id === value)
                // const data = ideaList[list.findIndex(item => item.value === value)]
                console.log(value, data, '创意规格');
                return ideaGroupFormItem(data?.ad_creative_list || []);
            })
    };
    const ideaGroupFormItem = (list) => {
        return createFormItem('WkListCheck', {
            value: _.head(list)?.value,
            field: 'idea_group',
            label: '素材规格',
            props: {
                list: list,
                label: '创意组'
            }
        }, (formState, acients, formData)=> {
            const value = formState.payload.value;
            const data = list.find(item => item.value === value)
            vm.global.formDataChange(acients,data.ele_list);
            return null;
        })
    }
    return appListFormItem;
};
export function observableMap(list, callback) {
    return list.map(item => Vue.observable( callback? callback(item) : item ))
}